// extracted by mini-css-extract-plugin
export default {"warning__wrapper":"warnings_warning__wrapper__nRibB","error":"warnings_error__VYJxJ","error__nowrap":"warnings_error__nowrap__hXWVg"};